import { create } from 'zustand';
import { clearState, loadCityState, cityState } from '../utils/persistState';

function buildInitialSession() {
  const city = loadCityState();
  return {
    /** Restored from GET /auth/me in useSessionBootstrap (not from localStorage). */
    user: null,
    city: city || null,
    policiesView: false,
    sessionHydrated: false,
  };
}

export const useSessionStore = create(set => ({
  ...buildInitialSession(),
  setUser: user => set({ user }),
  setCity: city => {
    cityState(city);
    set({ city });
  },
  setPoliciesVisible: visible => set({ policiesView: Boolean(visible) }),
  resetSession: () => {
    clearState();
    set({
      user: null,
      policiesView: false,
    });
  },
}));

export function useLoggedInUser() {
  return useSessionStore(state => state.user);
}

export function useSessionHydrated() {
  return useSessionStore(state => state.sessionHydrated);
}

export function usePoliciesVisible() {
  return useSessionStore(state => state.policiesView);
}

export function loggedinUser(payload) {
  useSessionStore.getState().setUser(payload);
}

export function cityName(payload) {
  useSessionStore.getState().setCity(payload);
}

export function viewPolicies(payload) {
  useSessionStore.getState().setPoliciesVisible(payload);
}

export function closePolicies(payload) {
  useSessionStore.getState().setPoliciesVisible(payload);
}

export function logoutAction() {
  useSessionStore.getState().resetSession();
}

export function logoutSession() {
  logoutAction();
}
